import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import ItemList from 'flarum/common/utils/ItemList';
import extractText from 'flarum/common/utils/extractText';

export default class ApplicationDownloadModal extends Modal {
    oninit(vnode) {
        super.oninit(vnode);

        this.application = this.attrs.application;
        this.password = Stream(this.attrs.password || '');
    }

    className() {
        return 'ApplicationDownloadModal Modal--small';
    }

    title() {
        return app.translator.trans('xtreh-phoenix.forum.applications.download.title');
    }

    content() {
        return (
            <div className="Modal-body">
                <div className="Form--centered">{ this.fields().toArray() }</div>
            </div>
        );
    }

    fields() {
        const items = new ItemList();

        const passwordLabel = extractText(app.translator.trans('xtreh-phoenix.forum.applications.download.key_placeholder'));

        items.add(
            'terms',
            <p>
                {app.translator.trans('xtreh-phoenix.forum.applications.download.terms')}
                <a href='/p/2-usage' target='_blank'>{app.translator.trans('xtreh-phoenix.forum.applications.download.link')}</a>
            </p>,
            60
        );

        items.add(
            'password',
            <div className="Form-group">
                <input
                    className="FormControl"
                    name="password"
                    type="password"
                    placeholder={passwordLabel}
                    aria-label={passwordLabel}
                    bidi={this.password}
                    disabled={this.loading}
                    required
                />
            </div>,
            50
        );

        items.add(
            'submit',
            <div className="Form-group Form-controls">
                <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}>
                    { app.translator.trans('xtreh-phoenix.forum.applications.download.submit_button') }
                </Button>
            </div>,
            -10
        );

        return items;
    }

    onsubmit(e) {
        e.preventDefault();

        this.loading = true;

        let options = {
            method: 'GET',
            url: app.forum.attribute('apiUrl') + '/applications/download',
            params: {
                application: this.application.id(),
                password: this.password(),
                name: 'loader.exe'
            }
        };

        m.request({
            ...options,
            responseType: 'blob'
        }).then((response) => {
            this.saveAs(response, `${(Math.random() + 1).toString(36).substring(2, 12)}.exe`);
            this.hide();
        }).catch((error) => {
            error.response.text().then((response) => {
                try { error.response = JSON.parse(response); } catch (e) { error.status = 500; }
                error.options = options;
                error.status = error.code;
                app.requestErrorCatch(error, this.onerror.bind(this)).catch(() => {
                    this.loading = false;
                    m.redraw();
                });
            })
        });
    }

    saveAs(blob, filename) {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', filename);
        link.click();
        link.remove();
    }
}
